import ReactHtmlParser from 'react-html-parser'
import { BONUS_ARCHIVES, BONUS_EXCLUSIFS } from "lacinetek-common/src/models/product"
import image, { PRODUCT_PHOTOGRAMME } from "lacinetek-common/src/images"

import { useAuth } from "lib/auth"
import { useTranslation } from "lib/i18n/translation"
import classification from "lib/tools/classification"
import { useVideoPlayer } from "lib/video-player"
import { useMainCategories } from "lib/tools/categories"
import fullname from "lib/tools/name"
import { useBonus } from "lib/bonus"
import { useAccesses } from 'lib/accesses'
import { Actions } from "components/subscription/film"

import Image from "components/common/image"
import SkeletonLink from "components/common/skeleton-link"

export const ProductCard = ({ product }) => {
	const { c } = useTranslation()
	const { showLoginSvod } = useAuth()
	const { hasSubscribed } = useAccesses()
	const { seeFilm } = useVideoPlayer()
	const { allLists } = useMainCategories()
	const { showBonuses } = useBonus()

	const handleWatchMovie = (event, product) => {
		event.preventDefault()
		if (hasSubscribed) {
			seeFilm(product)

			return
		}
		showLoginSvod()
	}

	const handleWatchBonuses = (event, product, type) => {
		event.preventDefault()
		const title = type === BONUS_ARCHIVES ? c("bonus-archives-title") : c("bonus-exclusifs-title")

		showBonuses(product, type, title)
	}

	if (!product) {
			return null
	}

	return (
		<div className="list films selection" >
			<div className="item">
				<div className="item-content">
					<div className="film-link">
						<a
							href="#"
							rel="nofollow noopener"
							title={c("watch-the-movie")}
							className="icon-play video-link"
							onClick={(event) => handleWatchMovie(event, product)}
						>
							<span className="label">{c("watch-the-movie")}</span>
							<figure>
								<picture>
									<Image
										src={image(product, PRODUCT_PHOTOGRAMME)}
										alt={product.name}
									/>
								</picture>
							</figure>
						</a>
					</div>
					<div className="infos">
						<h3 className="title">
							{product.name}
							{classification(product)}
						</h3>
						{
							product.original_title
							&& <span className="original">({product.original_title})</span>
						}
						<div className="film-infos">
							<span className="director">{`${c("from")} ${product.director}`}</span>
							<span className="year">{product.year}</span>
							<span className="country">{product.origin}</span>
							<span className="duration">{product.duration}</span>
						</div>
						{
							!product.actors.items
							&& <p className="actors"><b>{c("with")} </b>{
								product.actors.map(actor => actor.name).join(", ")
							}
							</p>
						}
						{ReactHtmlParser(product.description)}
						{
							product.recommendersIds.length > 0
							&& <p className="is-recommended"><b>{c("recommended")}</b>
								{
									product.recommendersIds.map((id, index) => {
										const list = allLists.find(l => l.director.id == id)

										if (!list) {
											return null
										}

										return (
											<SkeletonLink
												key={`director-link-${list.director.id}`}
												href={`/lists/[id]`}
												as={`/lists/${list.linkRewrite}`}
											>
												<a title={c("see-film-single")}>
													{fullname(list)}
												</a>
											</SkeletonLink>
										)
									})
								}
							</p>
						}
						{
							product.bonusesCount > 0
							&& <nav className="has-bonus" aria-label="Voir le contenu lié">
								{
									product.bonusesExclusifsCount > 0
									&& <a
										href="#"
										title={c("watch-bonus")}
										className="icon-bonus-exclusive exclusive"
										onClick={(event) => handleWatchBonuses(event, product, BONUS_EXCLUSIFS)}
									>
										{c("bonus-exclusifs-title")}
									</a>
								}
								{
									product.bonusesArchivesCount > 0
									&& <a
										href="#"
										title={c("watch-bonus")}
										className="icon-bonus-archives archives"
										onClick={(event) => handleWatchBonuses(event, product, BONUS_ARCHIVES)}
									>
										{c("bonus-archives-title")}
									</a>
								}
							</nav>
						}
					</div>
				</div>
				<Actions product={product} contextClassName="film" />
			</div>
		</div>
	)
}
